import { createFormAction } from 'redux-form-saga';
import * as substanceCosAnnexeFormTypes from './substanceCosAnnexeFormTypes';

export const submitSubstanceCosAnnexeForm = createFormAction(
  substanceCosAnnexeFormTypes.SUBMIT_SUBSTANCE_COSANNEXE_FORM,
);
